import React from 'react';
import { Link } from 'react-router-dom';

const WelcomePage = () => {
  return (
    <div className="container">
      <div className="header">
        <h1>NotesNCodes</h1>
        <p>Dental Student Queue Management System</p>
      </div>
      
      <div className="card">
        <h2 style={{ textAlign: 'center', marginBottom: '24px', color: 'var(--text-dark)' }}>
          Welcome to NotesNCodes
        </h2>
        
        <p style={{ textAlign: 'center', marginBottom: '32px', color: 'var(--text-light)' }}>
          Choose your login type to get started:
        </p>
        
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', 
          gap: '20px' 
        }}>
          <Link to="/student/login" className="card" style={{ 
            textDecoration: 'none', 
            padding: '24px', 
            textAlign: 'center',
            border: '2px solid var(--light-blue)',
            borderRadius: '12px',
            transition: 'all 0.3s ease'
          }}>
            <div style={{ fontSize: '48px', marginBottom: '12px' }}>🎓</div>
            <h3 style={{ color: 'var(--text-dark)', marginBottom: '8px' }}>Student Login</h3>
            <p style={{ color: 'var(--text-light)' }}>Join the queue for Dr. Grant's assistance</p>
          </Link>
          
          <Link to="/dr-grant/login" className="card" style={{ 
            textDecoration: 'none', 
            padding: '24px', 
            textAlign: 'center',
            border: '2px solid var(--coral)',
            borderRadius: '12px',
            transition: 'all 0.3s ease'
          }}>
            <div style={{ fontSize: '48px', marginBottom: '12px' }}>👩‍⚕️</div>
            <h3 style={{ color: 'var(--text-dark)', marginBottom: '8px' }}>Dr. Grant Login</h3>
            <p style={{ color: 'var(--text-light)' }}>Manage sessions and evaluate students</p>
          </Link>
        </div>
      </div>
      
      <div style={{ textAlign: 'center', marginTop: '24px' }}>
        <Link to="/test" style={{ color: 'var(--text-light)', fontSize: '14px' }}>
          Connection Test
        </Link>
        <span style={{ color: 'var(--text-light)', margin: '0 8px' }}>|</span>
        <Link to="/debug" style={{ color: 'var(--text-light)', fontSize: '14px' }}>
          Route Debug
        </Link>
      </div>
    </div>
  );
};

export default WelcomePage;